<template>
  <div class="battery-level-indicator">
    <div
      :class="{
        'battery-level-indicator--red': batteryStatus.color === 'red',
        'battery-level-indicator--green': batteryStatus.color === 'green',
      }"
    >
      <b-icon size="small" colored :icon="batteryStatus.icon" />
      <span>{{ `${batteryPercentage} %` }}</span>
    </div>
  </div>
</template>

<script>
/** Threshold from which we display the battery percentage in red */
const BATTERY_LOW = 20

export default {
  name: 'OBatteryLevelIndicator',

  props: {
    batteryPercentage: {
      type: Number,
      required: true,
    },
  },

  computed: {
    batteryStatus() {
      if (this.$props.batteryPercentage <= BATTERY_LOW) {
        return {
          color: 'red',
          icon: 'battery-half',
        }
      } else {
        return {
          color: 'green',
          icon: 'battery-full',
        }
      }
    },
  },
}
</script>

<style scoped>
.battery-level-indicator {
  display: flex;
  justify-content: start;
  margin: 0;
}
.battery-level-indicator--red {
  color: red;
}
.battery-level-indicator--green {
  color: green;
}
</style>
